import { Navigate as NAVIGATE } from "react-big-calendar";
import { createStyles, Theme, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import { makeStyles } from "@material-ui/core/styles";

interface Message {
  today: string;
  previous: string;
  next: string;
}

interface Localizer {
  messages: Message;
}

interface ToolbarProps {
  view: string;
  views: string[];
  label: JSX.Element;
  localizer: Localizer;
  onNavigate: (action: string) => void;
  onView: (view: string) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolbar: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      marginBottom: "10px",
      fontSize: theme.spacing(2),
      "& .btn-group": {
        whiteSpace: "nowrap",
      },
      "& .toolbar-label": {
        flexGrow: 1,
        padding: "0 10px",
        textAlign: "center",
      },
      "& .MuiButton-outlinedPrimary": {
        "&:hover": {
          color: theme.palette.primary.main,
          backgroundColor: "rgba(25, 118, 210, 0.14)",
        },
      },
    },
    selected: {
      backgroundColor: "rgba(25, 118, 210, 0.14)",
    },
    arrowContainer: {
      border: "0px solid ",
      "&:hover": {
        border: "none",
        backgroundColor: "transparent!important",
      },
    },
    todayLabel: {
      color: "#00A3A3",
      fontFamily: "Inter",
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 600,
    },
    leftArrow: {
      border: "solid #00A3A3",
      borderWidth: "0 3px 3px 0",
      display: "inline-block",
      padding: "3px",
      transform: "rotate(140deg)",
    },
    rightArrow: {
      border: "solid #00A3A3",
      borderWidth: "0 3px 3px 0",
      display: "inline-block",
      padding: "3px",
      transform: "rotate(-45deg)",
    },
  })
);

const Toolbar = ({
  views,
  view,
  localizer,
  label,
  onNavigate,
  onView,
}: ToolbarProps) => {
  const classes = useStyles();

  const viewNamesGroup = () => {
    return views.map((name) => (
      <Button
        type="button"
        key={name}
        className={view === name ? classes.selected : null}
        onClick={() => onView(name)}
      >
        {localizer.messages[name]}
      </Button>
    ));
  };

  const newParticipantToolbar = () => (
    <>
      <ButtonGroup
        color="primary"
        className="btn-group"
        aria-label="outlined primary button group"
      >
        <Typography
          className={classes.todayLabel}
          onClick={() => onNavigate(NAVIGATE.TODAY)}
        >
          {localizer.messages.today}
        </Typography>
        <Button
          className={classes.arrowContainer}
          onClick={() => onNavigate(NAVIGATE.PREVIOUS)}
        >
          <div className={classes.leftArrow} />
        </Button>
        <Button
          className={classes.arrowContainer}
          onClick={() => onNavigate(NAVIGATE.NEXT)}
        >
          <div className={classes.rightArrow} />
        </Button>
      </ButtonGroup>
      <span className="toolbar-label">{label}</span>

      <ButtonGroup
        color="primary"
        className="btn-group"
        aria-label="contained button group"
      >
        {viewNamesGroup()}
      </ButtonGroup>
    </>
  );
  return <div className={classes.toolbar}>{newParticipantToolbar()}</div>;
};

export default Toolbar;
